

import { X, Loader2, Building2, ScanBarcode } from 'lucide-react';

import { SOURCES } from './contactListTypes';
import { useContactsController } from './useContactsController';
export function ContactCreateDialog({ ctx }: { ctx: ReturnType<typeof useContactsController> }) {
const { accounts, products, showModal, setShowModal, saving, form, setForm, gstFetching, gstFetched, setGstFetched, gstCompanyName, setGstCompanyName, setGstEnrichment, handleGstLookup, handleCreate } = ctx;
return (<>{showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={() => setShowModal(false)}>
          <div className="mx-4 w-full max-w-lg rounded-xl bg-white shadow-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4 rounded-t-xl">
              <h2 className="text-lg font-semibold text-gray-900">Add Contact</h2>
              <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-600">
                <X size={20} />
              </button>
            </div>
            <div className="space-y-4 px-6 py-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">First Name *</label>
                  <input
                    type="text"
                    value={form.firstName}
                    onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                  />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Last Name *</label>
                  <input
                    type="text"
                    value={form.lastName}
                    onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                  />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Email *</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Phone</label>
                  <input
                    type="tel"
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                  />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Title</label>
                  <input
                    type="text"
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                  />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Product Interest</label>
                <div className="relative">
                  <div
                    className="min-h-[38px] w-full cursor-pointer rounded-lg border border-gray-300 px-3 py-1.5 text-sm focus-within:border-[var(--ink-0)] focus-within:ring-1 focus-within:ring-[var(--ink-0)]"
                    onClick={() => {
                      const el = document.getElementById('pi-dropdown-create');
                      if (el) el.classList.toggle('hidden');
                    }}
                  >
                    {form.productInterest ? (
                      <div className="flex flex-wrap gap-1">
                        {form.productInterest.split(', ').map((p, i) => (
                          <span key={i} className="inline-flex items-center gap-1 rounded-full bg-purple-50 px-2 py-0.5 text-xs font-medium text-purple-700">
                            {p}
                            <button type="button" onClick={(e) => {
                              e.stopPropagation();
                              const updated = form.productInterest.split(', ').filter((_, idx) => idx !== i).join(', ');
                              setForm({ ...form, productInterest: updated });
                            }} className="text-purple-400 hover:text-purple-600"><X size={10} /></button>
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text-gray-400">Select products...</span>
                    )}
                  </div>
                  <div id="pi-dropdown-create" className="hidden absolute z-20 mt-1 w-full max-h-48 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
                    {products.map(p => {
                      const selected = form.productInterest.split(', ').filter(Boolean).includes(p.name);
                      return (
                        <label key={p.id} className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-50 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selected}
                            onChange={() => {
                              const current = form.productInterest.split(', ').filter(Boolean);
                              const updated = selected ? current.filter(x => x !== p.name) : [...current, p.name];
                              setForm({ ...form, productInterest: updated.join(', ') });
                            }}
                            className="rounded border-gray-300 text-[var(--ink-0)] focus:ring-[var(--ink-0)]"
                          />
                          {p.name}
                        </label>
                      );
                    })}
                    {products.length === 0 && <div className="px-3 py-2 text-xs text-gray-400">No products found</div>}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Account</label>
                  <select
                    value={form.accountId}
                    onChange={(e) => setForm({ ...form, accountId: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                  >
                    <option value="">None</option>
                    {accounts.map(a => (
                      <option key={a.id} value={a.id}>{a.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Source</label>
                  <select
                    value={form.source}
                    onChange={(e) => setForm({ ...form, source: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                  >
                    <option value="">Select Source</option>
                    {SOURCES.map(s => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">Customer Type</label>
                  <select
                    value={form.customerType}
                    onChange={(e) => {
                      setForm({ ...form, customerType: e.target.value });
                      if (e.target.value === 'b2c') {
                        setGstFetched(false); setGstCompanyName(''); setGstEnrichment(null);
                        setForm(f => ({ ...f, customerType: 'b2c', gstin: '' }));
                      }
                    }}
                    className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                  >
                    <option value="b2c">B2C — Individual Consumer</option>
                    <option value="b2b">B2B — Business Buyer</option>
                  </select>
                </div>
              </div>
              {/* GST Lookup — shown when B2B */}
              {form.customerType === 'b2b' && (
                <div className="rounded-lg border border-blue-100 bg-blue-50/50 p-3">
                  <div className="flex items-center gap-2 mb-2">
                    <Building2 size={14} className="text-blue-600" />
                    <span className="text-xs font-semibold text-blue-700 uppercase tracking-wider">GST Details</span>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    <input
                      type="text"
                      placeholder="Enter 15-digit GSTIN"
                      value={form.gstin}
                      onChange={(e) => {
                        const v = e.target.value.toUpperCase().slice(0, 15);
                        setForm({ ...form, gstin: v });
                        if (v.length === 15) handleGstLookup(v);
                      }}
                      maxLength={15}
                      className={`flex-1 rounded-lg border px-3 py-2 text-sm font-mono focus:border-[var(--ink-0)] focus:outline-none ${gstFetched ? 'border-green-300 bg-green-50' : 'border-gray-300'}`}
                    />
                    <button
                      type="button"
                      onClick={() => handleGstLookup(form.gstin)}
                      disabled={form.gstin.length !== 15 || gstFetching}
                      className="flex items-center gap-1 rounded-lg bg-blue-600 px-3 py-2 text-xs font-medium text-white hover:bg-blue-700 disabled:opacity-50"
                    >
                      {gstFetching ? <Loader2 size={12} className="animate-spin" /> : <ScanBarcode size={12} />}
                      Lookup
                    </button>
                  </div>
                  {gstFetched && gstCompanyName && (
                    <div className="flex items-center gap-2 text-sm">
                      <span className="text-green-600 font-medium">✓ {gstCompanyName}</span>
                      <span className="text-xs text-gray-500">(Account will be auto-created)</span>
                    </div>
                  )}
                  {!gstFetched && !gstFetching && form.gstin.length > 0 && form.gstin.length < 15 && (
                    <p className="text-xs text-gray-400">{15 - form.gstin.length} more characters needed</p>
                  )}
                </div>
              )}
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Tags</label>
                <input
                  type="text"
                  placeholder="Comma-separated tags"
                  value={form.tags}
                  onChange={(e) => setForm({ ...form, tags: e.target.value })}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                />
              </div>
              <div className="border-t border-gray-100 pt-3">
                <p className="mb-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Location</p>
                <div className="grid grid-cols-2 gap-3 mb-3">
                  <input type="text" placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                  <input type="text" placeholder="State" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                </div>
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Notes</label>
                <textarea
                  rows={3}
                  placeholder="Free-form notes about this contact..."
                  value={form.notes}
                  onChange={(e) => setForm({ ...form, notes: e.target.value })}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                />
              </div>
              <div className="border-t border-gray-100 pt-3">
                <p className="mb-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Address</p>
                <div className="space-y-3">
                  <input type="text" placeholder="Street" value={form.street} onChange={(e) => setForm({ ...form, street: e.target.value })}
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                  <div className="grid grid-cols-3 gap-3">
                    <input type="text" placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                    <input type="text" placeholder="State" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                    <input type="text" placeholder="Pincode" value={form.pincode} onChange={(e) => setForm({ ...form, pincode: e.target.value })}
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]" />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 border-t border-gray-200 px-6 py-4">
              <button
                onClick={() => setShowModal(false)}
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleCreate}
                disabled={saving || !form.firstName || !form.lastName || !form.email}
                className="flex items-center gap-2 rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--ink-1)] disabled:opacity-50"
              >
                {saving && <Loader2 size={14} className="animate-spin" />}
                Create Contact
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Contact Modal */}
      </>);
}
